// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__yV9ce","title":"Images90_title__6Nz1V","images":"Images90_images__1w4gO"};